import { render } from "./AddCallCenterNoteModal.vue?vue&type=template&id=60c1df7e&ts=true"
import script from "./AddCallCenterNoteModal.vue?vue&type=script&lang=ts"
export * from "./AddCallCenterNoteModal.vue?vue&type=script&lang=ts"

import "./AddCallCenterNoteModal.vue?vue&type=style&index=0&id=60c1df7e&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__